import { RootState } from '../reducers'

export const grcYpokConfigSelector = (state: RootState) => (state.grcYpok.config ? state.grcYpok.config : null)
